var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "payment-page" } },
    [
      _c("loading-overlay", {
        attrs: {
          active: _vm.displayLoader,
          loader: "dots",
          color: "#1A74DB",
          height: "30",
          width: "100%",
          opacity: "0.85",
        },
        on: {
          "update:active": function ($event) {
            _vm.displayLoader = $event
          },
        },
      }),
      _vm._v(" "),
      _vm.pageDataFetched
        ? _c(
            "div",
            [
              _c("checkout-header", {
                attrs: {
                  categoryFilter: { display: false },
                  shoppingBag: { display: false },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { id: "body" } },
                [
                  _c("div", { staticClass: "row block" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col xs-12",
                        staticStyle: { padding: "0" },
                      },
                      [
                        !_vm.isPmUpdate
                          ? _c(
                              "div",
                              [
                                _vm.disclaimer
                                  ? _c("notice", {
                                      attrs: { noticeType: "notice" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "content",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(_vm.disclaimer) +
                                                    "\n              "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        485131354
                                      ),
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isDeferred && !_vm.isSoftwareCartEmpty
                                  ? _c("notice", {
                                      attrs: { noticeType: "notice" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "content",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(_vm.paymentNotice) +
                                                    "\n              "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        664816409
                                      ),
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isUpfrontPayment && !_vm.isSoftwareCartEmpty
                                  ? _c("notice", {
                                      attrs: { noticeType: "notice" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "content",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.checkoutContent
                                                        .upfrontPaymentNotice
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1735568178
                                      ),
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("h3", { staticClass: "margin-top-50" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.checkoutSharedContent.paymentDetails) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "black bold",
                            attrs: { id: "ssl-notice" },
                          },
                          [
                            _c("span", {
                              staticClass: "icon small inline lock",
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.paymentMethod === "ACH"
                                    ? "Banking data encrypted and secure"
                                    : _vm.checkoutSharedContent.sslEncryption
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.paymentMethod === "Invoice"
                    ? [
                        _c("invoice-info", {
                          attrs: {
                            newBillingProcessApproved:
                              _vm.newBillingProcessApproved,
                          },
                        }),
                      ]
                    : _vm.paymentMethod !== "Invoice"
                    ? [
                        _vm.defaultPaymentMethod
                          ? _c("div", [
                              _c("div", { staticClass: "default-card" }, [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "default-payment-info" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.checkoutSharedContent
                                            .enterPaymentInfo
                                            .defaultPaymentMethod
                                        ) + ":"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "default-payment-info" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.paymentMethodName) +
                                          " ****" +
                                          _vm._s(_vm.defaultPaymentMethod.last4)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.defaultPaymentMethod.expMonth &&
                                  _vm.defaultPaymentMethod.expYear
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "default_payment_expiration",
                                        },
                                        [
                                          _vm._v(
                                            "Exp " +
                                              _vm._s(_vm.expirationMonth) +
                                              "/" +
                                              _vm._s(
                                                _vm.defaultPaymentMethod.expYear
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "default_note" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.checkoutSharedContent.enterPaymentInfo
                                      .defaultPaymentNote
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", [
                          _vm.enterPaymentInfoHeader && !_vm.showAchMandate
                            ? _c(
                                "h5",
                                { staticStyle: { "margin-top": "40px" } },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.enterPaymentInfoHeader) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "border border-[#A9B7C0] rounded-[3px] mb-[1.5rem]",
                          },
                          [
                            _c("new-stripe-element", {
                              attrs: {
                                stripe: _vm.stripe,
                                stripeOptions: _vm.stripeOptions,
                              },
                              on: {
                                "stripe-payment": _vm.handleStripeSubmit,
                                "stripe-form-change":
                                  _vm.handleStripeFormChange,
                              },
                            }),
                            _vm._v(" "),
                            _vm.showUpdateDefaultPaymentMethod &&
                            !_vm.isPmUpdate
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-lg flex align-middle px-[18px] py-[15px] mb-[15px]",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.setAsDefault,
                                          expression: "setAsDefault",
                                        },
                                      ],
                                      staticClass:
                                        "!m-0 !mr-[15px] h-[30px] w-[30px] min-w-[30px]",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(_vm.setAsDefault)
                                          ? _vm._i(_vm.setAsDefault, null) > -1
                                          : _vm.setAsDefault,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.setAsDefault,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.setAsDefault = $$a.concat([
                                                  $$v,
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.setAsDefault = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.setAsDefault = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "my-auto" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.checkoutSharedContent
                                              .enterPaymentInfo
                                              .saveAsDefaultBold
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.checkoutSharedContent
                                              .enterPaymentInfo
                                              .saveAsDefaultNotBold
                                          )
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.hasCCFee
                          ? _c("div", [
                              _c("p", { staticClass: "default_note" }, [
                                _vm._v(
                                  "Note: " +
                                    _vm._s(
                                      _vm.checkoutContent.ccAdditionalFeeNote
                                    )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.creditCardLimitExceeded
                          ? _c("div", { staticClass: "cc-notice-wrapper" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.checkoutSharedContent.notices
                                      .please_note
                                  ) + " "
                                ),
                              ]),
                              _vm._v(
                                _vm._s(
                                  _vm.checkoutSharedContent.notices.credit_limit_exceeded
                                    .replace(
                                      "__limit__",
                                      _vm.creditCardLimit[_vm.currencyIsoCode]
                                    )
                                    .replace(
                                      "__currencyCode__",
                                      _vm.currencyIsoCode
                                    )
                                    .replace("__email__", _vm.ownerEmail)
                                ) + "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canSeeAutoRenewalExperiment &&
                        _vm.writtenLanguage === "English" &&
                        _vm.autoRenewalOptOut &&
                        _vm.stripeOptions.customerId
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "text-lg border border-[#A9B7C0] flex align-middle px-[18px] py-[15px] rounded-[3px] mt-[37px] mb-[50px]",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.hasOptedIntoAutoRenewal,
                                      expression: "hasOptedIntoAutoRenewal",
                                    },
                                  ],
                                  staticClass:
                                    "!m-0 !mr-[15px] h-[30px] w-[30px] min-w-[30px]",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.hasOptedIntoAutoRenewal
                                    )
                                      ? _vm._i(
                                          _vm.hasOptedIntoAutoRenewal,
                                          null
                                        ) > -1
                                      : _vm.hasOptedIntoAutoRenewal,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.hasOptedIntoAutoRenewal,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.hasOptedIntoAutoRenewal =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.hasOptedIntoAutoRenewal = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.hasOptedIntoAutoRenewal = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "my-auto" }, [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.renewalsPersistedVariables
                                          .jsonContent.text.optIn
                                      )
                                    ),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.renewalsPersistedVariables
                                          .jsonContent.text.autoRenew
                                      )
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.chargeImmediately || _vm.isENT
                          ? _c("div", { staticClass: "row text-center pt-1" }, [
                              _c("div", { staticClass: "col xs-12 text-2xl" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      `${_vm.totalText}: ${_vm.currencySymbol}${_vm.calculateTotal}`
                                    ) +
                                    "\n          "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.paymentType === "us_bank_account" &&
                        !_vm.showAchMandate
                          ? _c(
                              "div",
                              { staticClass: "col xs-12 text-center" },
                              [
                                _c(
                                  "h3",
                                  {
                                    staticClass: "mandate-h3 bold mb-0 pt-0.5",
                                  },
                                  [
                                    _vm._v(
                                      "\n            ACH privacy and Safety policies\n          "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "blue-text underline cursor-pointer",
                                    attrs: {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href: "https://support.stripe.com/questions/who-can-access-data-from-my-linked-financial-account-and-for-what-purposes",
                                    },
                                  },
                                  [_vm._v("Data Privacy")]
                                ),
                                _vm._v(",\n          "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "blue-text underline cursor-pointer",
                                    attrs: {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href: "https://support.stripe.com/questions/who-will-obtain-my-financial-institution-login-credentials",
                                    },
                                  },
                                  [_vm._v("Login Protection")]
                                ),
                                _vm._v(",\n          "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "blue-text underline cursor-pointer",
                                    attrs: {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href: "https://support.stripe.com/questions/is-my-financial-account-information-safe",
                                    },
                                  },
                                  [_vm._v("Account Safety")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : [
                        _c("div", { staticClass: "display-card" }, [
                          _c("p", { staticClass: "display-card-text" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.achPaymentCompanyName) +
                                "\n            "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "display-card-icon",
                                class: _vm.isMicro && "pending",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isMicro
                                      ? "Pending Verification"
                                      : "Linked   ✓"
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.isMicro
                          ? _c("div", [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "bold dark-blue-text email-verification",
                                },
                                [
                                  _vm._v(
                                    "\n            Microdeposit verification email will be sent to: " +
                                      _vm._s(_vm.email) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ],
                  _vm._v(" "),
                  _vm.paymentSubmissionError
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col xs-12 small-text red-text",
                            attrs: { id: "errors" },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.paymentSubmissionError) +
                                "\n        "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.paymentMethod === "BACS"
                    ? _c(
                        "div",
                        { staticClass: "margin-top-20 margin-bottom-100" },
                        [
                          _c("div", { attrs: { id: "body" } }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", {
                                staticClass: "col xs-12",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.checkoutSharedContent.bacsNotice
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              attrs: { id: "contact-information" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.checkoutSharedContent
                                    .samsaraContactInformation
                                ),
                              },
                            }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.paymentMethod === "ACSS"
                    ? _c(
                        "div",
                        { staticClass: "margin-top-50 margin-bottom-100" },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm.checkoutContent.legalNotices
                                  .acss_mandate_header
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("h5", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.checkoutContent.legalNotices
                                    .date_of_acceptance
                                ) +
                                ":\n          " +
                                _vm._s(_vm.currentDate) +
                                "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.checkoutContent.legalNotices
                                    .acss_mandate_body
                                ) +
                                "\n        "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.paymentMethod === "ACH" && _vm.showAchMandate
                    ? _c(
                        "div",
                        {
                          staticClass: "margin-top-50 margin-bottom-50 mandate",
                        },
                        [
                          _c("h3", { staticClass: "mandate-h3" }, [
                            _vm._v(
                              '\n          By clicking "' +
                                _vm._s(
                                  _vm.chargeImmediately
                                    ? _vm.isMicro
                                      ? _vm.checkoutSharedContent
                                          .enterPaymentInfo.microButtonText
                                      : _vm.checkoutSharedContent.makePayment
                                    : _vm.checkoutSharedContent
                                        .updatePaymentMethod
                                ) +
                                '", you authorize Samsara Inc. ("Samsara") to debit the bank\n          account specified above for any amount owed for charges arising from\n          your use of Samsara services and/or purchase of products from\n          Samsara, pursuant to Samsara’s\n          '
                            ),
                            _c(
                              "a",
                              {
                                staticStyle: { "text-decoration": "underline" },
                                attrs: {
                                  href: "https://www.samsara.com/legal/platform-terms-of-service/",
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [_vm._v("terms of service")]
                            ),
                            _vm._v(
                              ", until you revoke the authorization. You may amend or cancel this\n          authorization at any time by providing 30 (thirty) days written\n          notice to Samsara.\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("h5", { staticClass: "mandate-h5" }, [
                            _vm._v(
                              "\n          If you use Samsara's services or purchase additional Samsara\n          products periodically pursuant to Samsara’s terms, you authorize\n          Samsara to debit your bank account periodically. Payments that fall\n          outside of the regular debits authorized above will only be debited\n          after your authorization is obtained.\n        "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canceledInstantVerificationModal
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col margin-top-20 xs-12 medium-text",
                            attrs: { id: "errors" },
                          },
                          [
                            _vm._v(
                              "\n          We see you've closed the Connect Account window. Are you looking to\n          pay via Credit Card? If so click\n          "
                            ),
                            _c("a", { attrs: { click: _vm.routeToReview } }, [
                              _vm._v("here"),
                            ]),
                            _vm._v(
                              " and then select Credit Card from\n          the drop down.\n        "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hideSubmitButton
                    ? _c("submit-button", {
                        staticClass: "b-width",
                        attrs: {
                          id: "submit-button",
                          position: "center margin-top-20 margin-bottom-50",
                          mobile: "12",
                          tablet: "3",
                          desktop: "3",
                          styling: "primary",
                          form: "payment-form",
                          disabled: _vm.disableSubmitButton,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.submitButtonText) +
                                      "\n        "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3965661062
                        ),
                      })
                    : _vm.showInvoiceButton
                    ? _c("submit-button", {
                        staticClass: "b-width",
                        attrs: {
                          id: "submit-button",
                          position: "center margin-top-20 margin-bottom-50",
                          mobile: "12",
                          tablet: "3",
                          desktop: "3",
                          styling: "primary",
                          disabled: _vm.disableSubmitButton,
                        },
                        on: { onClickEvent: _vm.submitPaymentHandler },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.submitButtonText) +
                                      "\n        "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3965661062
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAchMandate
                    ? _c(
                        "p",
                        {
                          staticClass: "change-bank",
                          on: { click: _vm.changeBankAccount },
                        },
                        [_vm._v("\n        Change bank account\n      ")]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("MicroModal", {
        attrs: { isOpen: _vm.showMicroModal },
        on: {
          "hide-modal": function ($event) {
            _vm.showMicroModal = false
          },
          "submit-payment-data": _vm.submitPaymentHandler,
          "route-to-review": _vm.routeToReview,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }